import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => {
  const carSize = theme.spacing(8);
  return createStyles({
    icon: {
      fontSize: carSize,
      width: carSize,
      height: carSize,
      [theme.breakpoints.down('sm')]: {
        fontSize: carSize * 0.8,
        width: carSize * 0.8,
        height: carSize * 0.8
      },
      gridColumn: '1 / 1',
      gridRow: '1 / 1'
    }
  });
});